import React, { useState, useContext } from 'react';
import { Divider, Typography, ThemeProvider, Modal } from '@common-ui/ui';
import CreateNewReport from '../../components/CreateNewReport';
import AddToReport from '../../components/AddToReport';
import DarkTheme from '../../../../../styles/DarkTheme';
import { ModalContext } from '../..';
import { useSelector } from 'react-redux';

/**
 * This is the modal for creating a report
 * It is used in the Images page and the Reports page
 * It is opened by clicking the "Create New Report" button
 * It is also opened by clicking the "Add to Report" button
 * It contains the Title, CreateNewReport, and AddToReport components
 *
 * @param {*} param
 * @param {string} param.title - The title of the modal
 * @param {JSX.Element} param.children - The button that opens the modal
 * @param {object} param.data - The data for the modal
 * @param {function} param.setData - The function to set the data for the modal
 * @param {boolean} param.showAddToReport - Whether or not to show the add to report button
 * @returns {JSX.Element} - The modal
 *
 * TODO: Use either Zustand or useContext to manage the state of the modal
 * and avoid prop drilling
 */
export default function Report() {
  const { modal, closeModal } = useContext(ModalContext);
  const [open, setOpen] = useState('CreateNewReport');
  const { selectedImageIds = [] } = useSelector((state) => state.images);

  return (
    <ThemeProvider theme={DarkTheme}>
      <Modal open onClose={closeModal}>
        <div style={container}>
          <div style={title}>
            <Typography sx={text}>{modal.title}</Typography>
          </div>
          <div style={accordions}>
            <CreateNewReport open={open} setOpen={setOpen} selectedImageIds={selectedImageIds} />
            <Divider>OR</Divider>
            <AddToReport open={open} setOpen={setOpen} selectedImageIds={selectedImageIds} />
          </div>
        </div>
      </Modal>
    </ThemeProvider>
  );
}

const text = {
  textAlign: 'center',
  width: '500px',
  fontSize: '22px',
};

const container = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '554px',
  height: '604px',
  boxShadow: 24,
  opacity: 1,
  padding: '24px',
  background: '#232323',
  border: '2px solid #000',
  color: 'white',
};

const title = {
  display: 'flex',
  alignItems: 'center',
  padding: '12px 48px 12px 60px',
};

const accordions = {
  borderTop: '1px solid rgba(255, 255, 255, 0.12)',
  borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
};
